import { c as _c } from "react/compiler-runtime";
export type LogoProps = React.HTMLAttributes<SVGElement>;
export const Logo = props => {
  const $ = _c(11);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M96 31h91c65 0 107 46.5 107 109s-42 109-107 109H96" stroke="var(--logo-primary, #00566A)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="36" />;
    t1 = <path d="M36 34h.01M36 105h.01M36 176h.01M36 247h.01" stroke="var(--logo-primary, #00566A)" strokeLinecap="round" strokeWidth="48" />;
    t2 = <path d="M112 105h72" stroke="currentColor" strokeLinecap="round" strokeWidth="12" />;
    t3 = <path d="M184 105v71h68" stroke="var(--logo-accent, #18DDEA)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="14" />;
    t4 = <circle cx="112" cy="105" fill="currentColor" r="22" />;
    t5 = <circle cx="184" cy="105" fill="currentColor" r="22" />;
    t6 = <circle cx="112" cy="176" fill="currentColor" r="22" />;
    t7 = <circle cx="184" cy="176" fill="var(--logo-accent, #18DDEA)" r="22" />;
    t8 = <circle cx="252" cy="176" fill="var(--logo-accent, #18DDEA)" r="22" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props) {
    t9 = <svg fill="none" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 280">{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[9] = props;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
};